import { useState } from "react";
import "../assets/styles/Project.scss";
import passwordManagerImg from "../assets/images/password_manager.png";
import lavishLayers from "../assets/images/lavish_layers.webp";
import GitHubIcon from "@mui/icons-material/GitHub";
import LaunchIcon from "@mui/icons-material/Launch";
import CloseIcon from "@mui/icons-material/Close";

const projectData = [
  {
    title: "PassShield",
    github: "https://github.com/VedantCode04/password-manager",
    image: passwordManagerImg,
    description:
      "Zero Knowledge Encryption based password manager to protect sensitive data.",
    details:
      "PassShield is a full-stack password manager built using Angular 19, ExpressJS, and MongoDB. It implements zero-knowledge encryption via the Web Crypto API. It includes features like auto password generation, category organization, clipboard protection, and offline-first UX. The backend is optimized for speed and security with secure password hashing, JWT authentication, and rate-limiting.",
    tech: [
      "Angular 19",
      "RxJS",
      "ExpressJS",
      "MongoDB",
      "Mongoose",
      "Web Crypto API",
    ],
  },
  {
    title: "Lavish Layers",
    github: "https://github.com/vedantcode04/ecom-client-react",
    link: "https://www.youtube.com/watch?feature=shared&v=onQrh4ArdKg",
    image: lavishLayers,
    description:
      "A ecommerce website made with Strapi CMS and ReactJS alongside redux toolkit for state management",
    details:
      "A fully functional e-commerce website with features like searchin products, viewing all products available, shopping cart, filtering by categories, price range and sub categories and Admin Panel for adding, updating and deleting the products, categories , subcategories and a checkout page.",
    tech: ["React JS", "Strapi CMS", "Redux Toolkit", "MySql"],
  },
];

function Project({ mode }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [activeProject, setActiveProject] = useState(null);

  const openModal = (project) => {
    setActiveProject(project);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setActiveProject(null);
  };

  return (
    <div className="projects-container" id="projects">
      <h1>Personal Projects</h1>
      <div className="projects-grid">
        {projectData.map((project, index) => (
          <div className={`project ${mode}`} key={index}>
            <img
              src={project.image}
              className="zoom"
              alt={project.title}
              width="100%"
            />
            <h2 className="project-title">
              <div>{project.title} </div>
              <div>
                <button
                  className={`details-button ${mode}`}
                  onClick={() => openModal(project)}
                >
                  Details
                </button>
              </div>
            </h2>
            <p>{project.description}</p>

            <div className="tech-stack">
              {project.tech.map((tech, idx) => (
                <span className={`tech-pill ${mode}`} key={idx}>
                  {tech}
                </span>
              ))}
            </div>

            <div className="project-links">
              <a
                href={project.github}
                target="_blank"
                rel="noreferrer"
                className={`icon-link ${mode}`}
              >
                <GitHubIcon fontSize="small" />
                GitHub
              </a>
              {project.link && (
                <a
                  href={project.link}
                  target="_blank"
                  rel="noreferrer"
                  className={`icon-link ${mode}`}
                >
                  <LaunchIcon fontSize="small" />
                  Live
                </a>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {modalOpen && activeProject && (
        <div className={`modal-overlay ${mode}`} onClick={closeModal}>
          <div
            className={`modal-content ${mode}`}
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-button" onClick={closeModal}>
              <CloseIcon />
            </button>
            <h2>{activeProject.title}</h2>
            <p>{activeProject.details}</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default Project;
